import ModalController from 'webmodals/modal.controller'
import Design from 'emun.on-demand/lib/design'
import DesignLayer from 'emun.on-demand/lib/design-layer'
import resolve from 'ioc/resolve'
import utils from 'emun.on-demand/lib/util'
import ssUtils from 'webutils/services/util';

class PositionOverlayPromptController extends ModalController {
    constructor($uibModalInstance, options) {
        super($uibModalInstance)
        const $ctrl = this;
        $ctrl.title = options.title || 'Configure Overlay...';
        $ctrl.subTitle = options.subTitle || options.overlay.label;
        $ctrl.isUnderlay = options.isUnderlay;
        $ctrl.area = options.area;
        $ctrl.overlay = options.overlay;
        $uibModalInstance.closed.finally(() => $ctrl.designer.dispose());
        console.debug('PositionOverlayPromptController', options);
    }

    initializeDesigner(designer){
        console.debug('PositionOverlayPromptController.initializeDesigner', designer);
        let $ctrl = this;
        $ctrl.designer = designer;
        designer.ready = false;
        designer.isLoading = true;
        designer.status = 'loading';
        let guide = {
            type: 'rect',
            layerId: 'EFS-Design_Area',
            left: $ctrl.overlay.x,
            top: $ctrl.overlay.y,
            width: $ctrl.area.width,
            height: $ctrl.area.height,
            fill: '#f500f5',
            selectable: true,
            perPixelTargetFind: false,
            hasRotatingPoint: false,
            lockMovementX: false,
            lockMovementY: false,
            lockScalingX: false,
            lockScalingY: false,
            lockUniScaling: true,
            lockRotation: true
        };
        let overlays = $ctrl.area[$ctrl.isUnderlay === true ? 'underlays' : 'overlays']

        overlays.forEach(o => {
            
            console.debug('overlays.forEach', o);
            if(o !== $ctrl.overlay && o.x === 0 && o.y === 0 && o.width === $ctrl.area.width && o.height === $ctrl.area.height){
                guide.type = 'image';
                guide.src = guide.url = o.media.img('medium');
                //delete guide.fill;
                console.warn('guide', guide);
            }
        });

        let d = new Design({
            width: $ctrl.overlay.width,
            height: $ctrl.overlay.height,
            overscan:10,
            background: $ctrl.area.backgroundColor || '#fff',
            perspective: {
                media: $ctrl.overlay.media,
                x: 0,
                y: 0,
                width: $ctrl.overlay.width,
                height: $ctrl.overlay.height,
                opacity: 0.8
            },
            objects: [guide]
        }, false);
        console.debug('Design', d);
        designer.designs = [d];
        
        designer.activate(d);
        designer.ready = true;
        designer.isLoading = false;
        designer.status = 'ready';
        //designer.layers.shapes[0].select();
    }

    size(type) {
        const $ctrl = this;
        const designer = $ctrl.designer;
        const design = designer.design;
        designer.getObjects().forEach(o => {
            let scale = utils['get' + (type === 'cover' ? 'Cover':'Contain') +  'Scale'](o, design);
            o.set({
                scaleX: scale,
                scaleY: scale,
                left: (design.width / 2) - (o.width * scale / 2),
                top: (design.height / 2) - (o.height * scale/ 2),
                originX: 'left',
                originY: 'top'
            });
            o.setCoords();
        });
        resolve('$rootScope').$emit('designerObjectModified', {  });
    }

    submit() {
        const $ctrl = this;
        const designer = $ctrl.designer;
        const guide = $ctrl.designer.getObjects()[0];
        $ctrl.overlay.width = Math.round($ctrl.overlay.width / guide.scaleX);
        $ctrl.overlay.height = Math.round($ctrl.overlay.height / guide.scaleX);
        $ctrl.overlay.x = Math.round(guide.left / guide.scaleX);
        $ctrl.overlay.y = Math.round(guide.top / guide.scaleX);      
        $ctrl.close($ctrl);
    }
}

export default PositionOverlayPromptController;